import BrowserService from '@/services/browserService'

export default (user, page) => {
  const payload = ({
    event: 'page_view',
    platform: BrowserService.platform(),
    site: import.meta.env.VITE_VUE_APP_SITE_NAME,
    language: import.meta.env.VITE_VUE_APP_LOCALE,
    sessionId: BrowserService.sessionId(),
    page: page,
    ecommerce: {
      user,
    },
    _clear: true,
  })
  window.dataLayer?.push(payload)
}
